export default class Memory {
  constructor (width, height) {
    this.width = width
    this.height = height

    this.memory = []
    for (let i = 0; i < this.height; i++) {
      this.memory[i] = []
      for (let j = 0; j < this.width; j++) {
        this.memory[i][j] = { value: 0, callbacks: [] }
      }
    }

    this.callbacks = []
  }

  get (y, x) {
    return this.memory[y][x].value
  }

  getIndirect (y, x) {
    // Treat the value at (y, x) as a hex address of another cell, and return that value
    const hexCoords = this.memory[y][x].value
    return this.get(Math.floor(hexCoords / 16), hexCoords % 16)
  }

  set (y, x, value) {
    if (y > 11 || x > 15) {
      const e = new Error('Out of bounds access')
      e.name = 'OutOfBoundsError'
      throw e
    }

    const cell = this.memory[y][x]

    if (value === cell.value) {
      return
    }

    cell.value = value
    for (let i = 0; i < cell.callbacks.length; i++) {
      cell.callbacks[i](value)
    }
    for (let i = 0; i < this.callbacks.length; i++) {
      this.callbacks[i](y, x, value)
    }
  }

  setIndirect (y, x, value) {
    if (y > 11 || x > 15) {
      const e = new Error('Out of bounds access')
      e.name = 'OutOfBoundsError'
      throw e
    }

    // Treat the value at (y, x) as a hex address of another cell, and set the value of that cell
    const hexCoords = this.memory[y][x].value
    return this.set(Math.floor(hexCoords / 16), hexCoords % 16, value)
  }

  replaceAll (v1, v2) {
    for (let y = 0; y < this.height; y++) {
      for (let x = 0; x < this.width; x++) {
        if (this.memory[y][x] === v1) {
          this.set(y, x, v2)
        }
      }
    }
  }

  watch (y, x, callback) {
    this.memory[y][x].callbacks.push(callback)
  }

  watchAll (callback) {
    this.callbacks.push(callback)
  }

  offset (y, x) {
    return new MemoryOffset(this, y, x)
  }

  cell (y, x) {
    return new MemoryCell(this, y, x)
  }
}

class MemoryOffset {
  constructor (memory, baseY, baseX) {
    ;[ 'get', 'getIndirect', 'set', 'setIndirect', 'watch', 'offset', 'cell' ].forEach((name) => {
      const target = memory[name]
      this[name] = (y, x, ...args) => {
        return target.apply(memory, [ baseY + y, baseX + x ].concat(args))
      }
    })

    this.replaceAll = (...args) => {
      return memory.replaceAll(...args)
    }

    this.watchAll = (callback) => {
      return memory.watchAll((y, x, value) => {
        callback(y - baseY, x - baseX, value)
      })
    }
  }
}

class MemoryCell {
  constructor (memory, y, x) {
    ;[ 'get', 'getIndirect', 'setIndirect', 'set', 'watch' ].forEach((name) => {
      const target = memory[name]
      this[name] = (...args) => {
        return target.apply(memory, [ y, x ].concat(args))
      }
    })
  }
}
